<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useWorksheetComposable } from './useWorksheetComposable';
import { useDialog } from 'primevue/usedialog';
import Button from 'primevue/button';
import ProcessTourPricingModal from './ProcessTourPricingModal.vue';

interface Props {
  isSearchAdditional?: boolean;
  isLoading?: boolean;
  isPromotionModal?: boolean;
  newPrice?: any;
  errorMessage?: string;
  newHcms?: any;
  isEmptyRespond?: boolean;
  processData?: any;
  tourSelected?: any;
}
const props = defineProps<Props>();

const emits = defineEmits<{ applyNewPricing: [value: any] }>();

const { loadingIcon } = useWorksheetComposable();

const { t } = useI18n({ useScope: 'global' });
const dialog = useDialog();

const handleViewPricing = () => {
  const dialogRef = dialog.open(ProcessTourPricingModal, {
    data: {
      listTour: props.processData,
      tourSelected: props.tourSelected
    },
    props: {
      header: t('common.preview'),
      maximizable: true,
      style: {
        width: '95vw'
      },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      },
      modal: true
    },
    emits: {
      onSaveSelectRoom: (data: any) => {
        emits('applyNewPricing', data);
        dialogRef.close();
      }
    }
  });
};
</script>
<template>
  <div class="progress-worksheet-modal">
    <div v-if="isLoading" class="flex align-items-center flex-col modal">
      <h2 class="font-bold text-2xl">{{ $t('worksheet.tour_call_progress') }}</h2>
      <p v-if="isPromotionModal">{{ $t('worksheet.retrieve_group') }}</p>
      <p v-else>{{ $t('worksheet.retrieve_tts') }}</p>
      <div class="w-3rem h-3rem rotage"><img class="w-full" :alt="$t('common.generic.loading')" :src="loadingIcon" /></div>
    </div>
    <div v-else-if="isSearchAdditional" class="flex align-items-center flex-col modal">
      <div class="font-bold text-2xl mb-2">{{ $t('worksheet.loading') }}</div>
      <div class="w-3rem h-3rem rotage"><img class="w-full" :alt="$t('common.generic.loading')" :src="loadingIcon" /></div>
    </div>
    <div v-else class="flex align-items-left flex-col modal">
      <p class="font-bold text-2xl text-center">{{ $t('worksheet.tour_call_completed') }}</p>
      <div v-if="!isPromotionModal" class="text-lg mb-3">
        <div v-if="!newPrice">
          <i class="pi pi-times-circle text-red-700 font-bold text-xl mr-1"></i>
          <span>{{ $t('common.error') }} - {{ errorMessage ? errorMessage : $t('worksheet.un_retrieve_tts') }}</span>
        </div>
        <div v-else>
          <i class="pi pi-check-circle text-green-700 font-bold text-xl mr-1"></i>
          <span>{{ $t('worksheet.succ_retrieve_tts') }}</span>
        </div>
      </div>
      <div v-else class="text-lg mb-3">
        <div v-if="!newHcms">
          <i class="pi pi-times-circle text-red-700 font-bold text-xl mr-1"></i>
          <span>{{ $t('worksheet.un_retrieve_hcms') }}</span>
        </div>
        <div v-else>
          <i class="pi pi-check-circle text-green-700 font-bold text-xl mr-1"></i>
          <span v-if="isEmptyRespond">{{ $t('worksheet.empty_retrieve_hcms') }}</span>
          <span v-else>{{ $t('worksheet.succ_retrieve_hcms') }}</span>
        </div>
      </div>
      <div :class="['flex justify-content-between', !isEmptyRespond && 'm-auto']">
        <Button id="view-pricing-btn" v-if="!isPromotionModal && processData.length" icon="pi pi-eye" :label="$t('common.buttons.view_pricing')" @click="handleViewPricing" />
        <Button v-if="isPromotionModal" icon="pi pi-check" :label="$t('common.buttons.close_apply')" />
      </div>
    </div>
  </div>
</template>
